export default {
    common: {
        email: 'メールアドレス',
        LoginBtn: 'ログイン',
        SignUpBtn: 'サインアップ',
        SubmitBtn: '送信',
        ExitBtn: '終了',
        LogoutBtn: 'ログアウト'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: 'メールに記載の認証コードをご確認ください。',
        VerificationCode: '認証コード'
    },
    header: {
        OrderHistory: '注文履歴',
        MYACCOUNT: 'マイアカウント',
        WelcomeBack: 'おかえりなさい'
    },
    detail: {
        TotalOrders: '注文合計',
        TotalProducts: '商品合計',
        WonderlandPoints: 'ワンダーランドポイント',
        APMCredits: 'APM積分',
        ExpireOn: '有効期間',
        NoAPMCredits: 'APM積分なし',
        CreditsLoading: '積分ロード中',
        Orders: '注文',
        Online: 'オンライン',
        Boutique: 'ブティック',
        Total: '合計',
        Delivered: '配達済み',
        NoData: 'データなし',
        Status: 'ステータス',
        item: '商品',
        items: '商品'
    },
    panel: {},
    entry: {
        Client: 'お客様',
        OrderDate: '注文日',
        DeliverDate: '配送日',
        Description: '説明',
        Total: '合計'
    },
    board: {
        Order: '注文',
        Date: '日付',
        Total: '合計'
    },
    order: {
        OrderID: '注文ID',
        PurchasePlace: '場所',
        PurchaseDate: '購入日',
        TotalPrice: '合計金額',
    },
    product: {
        Name: 'お名前',
        SKU: 'SKU',
        Size: 'サイズ',
        Quantity: '数量',
        Price: '価格',
        WarrantyUntil: '保証の有効期限',
    },
    ordersLayout: {
            pageTitleOrders: "ご注文",
            wonderlandPointsBrand: "WONDERLAND POINTS",
            navHomepage: "ホーム",
            navProfile: "プロフィール",
            navOrders: "ご注文",
            navWonderland: "Wonderland",
            navWishlist: "ウィッシュリスト",
            navContactUs: "お問い合わせ",
            navExchangeReturn: "交換・返品",
            footerExchangePolicy: "交換・返品ポリシー",
            footerShipping: "配送",
            footerPrivacy: "プライバシーポリシー",
            footerTerms: "利用規約",
            footerRegion: "フランス",
            menuTrackOrder: "配送を追跡",
            menuViewDetails: "詳細を見る",
            back: "戻る",
            orderNumberHeading: "注文番号 {{id}}",
            itemsCount_one: "{{count}} 点",
            itemsCount_other: "{{count}} 点",
            emptyOrders: "注文はありません",
            invoiceSoon: "準備中",
            storeAddressPending: "住所は後日表示",
            skuPrefix: "SKU",
            statusLabel: "ステータス",
            productNameFallback: "商品",
            tabOnline: "オンライン",
            tabOffline: "オフライン",
            learnMore: "詳細を見る",
            redeemInStore: "店舗で引き換え",
            dateLabel: "日付",
            itemSingular: "商品",
            statusConfirmed: "確認済み",
            purchaseDateLabel: "購入日：",
            monthJan: "1月",
            monthFeb: "2月",
            monthMar: "3月",
            monthApr: "4月",
            monthMay: "5月",
            monthJun: "6月",
            monthJul: "7月",
            monthAug: "8月",
            monthSep: "9月",
            monthOct: "10月",
            monthNov: "11月",
            monthDec: "12月",
            storeLabel: "店舗",
            downloadInvoice: "請求書をダウンロード",
            warrantyExpires: "保証期限",
            sizeLabel: "サイズ",
            subtotalLabel: "小計",
            totalLabel: "合計",
        },
}


// WEBPACK FOOTER //
// ./src/locales/jp/index.js